import $ from '../vendor/jquery';
$(function () {
  $('.header-nav-aux, .off-canvas-nav')
    .find('a[href$="#menu"]')
    .click(function(event) {
      event.preventDefault();
    });
})



// WEBPACK FOOTER //
// ./public/assets/js/src/components/auxNav.js